import { apiEndpoints } from "@/services/api/api";
import { ActionFunctionArgs } from "react-router-dom";

export async function adminManageCoursesInDetailAction({
  request,
}: ActionFunctionArgs) {
  const formData = await request.formData();
  const intent = formData.get("intent");
  const id = formData.get("id") as string;

  switch (intent) {
    case "delete": {
      const result = await apiEndpoints.lecturerDeleteCourse(id);
      return result;
    }
    case "create-section":
      // handle logic
      break;
    case "reorder-lessons":
      // handle logic
      break;
    default:
      throw new Error("Unknown intent");
  }
}
